// extracted by mini-css-extract-plugin
export default {"actions-box":"actionsSwitches_actions-box__6vMio","action-item":"actionsSwitches_action-item__QQ1Rp"};